import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/pro-solid-svg-icons";
import ActiveLink from "@/components/molecules/ActiveLink";

const nav = [
  { name: "プライバシー・ポリシー", sub: "", href: "/policy" },
  { name: "サイトのご利用について", sub: "", href: "/terms" },
  { name: "特定商取引法に基づく表記", sub: "", href: "/legal" },
  { name: "ISMS基本方針", sub: "（セキュリティ方針）", href: "/isms" },
  { name: "QMS基本方針", sub: "（品質方針）", href: "/qms" },
  { name: "AI活用方針", sub: "", href: "/ai_policy" },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function TermNav({}) {
  return (
    <>
      <ul className="order-2 mt-6 mb-8 flex min-w-max flex-col gap-2 border-y-4 border-x-0 border-solid border-y-bdc-light py-4 text-txt-base md:order-1 md:mt-0 md:mb-16  md:flex-row md:gap-6 md:border-x-0 md:border-t-0 md:border-b     md:border-solid md:border-b-bdc-base md:pt-0">
        {nav.map((nav) => (
          <li key={nav.name}>
            <ActiveLink
              href={nav.href}
              activeClassName="text-pri md:border-x-0 md:border-t-0 md:border-b md:border-solid"
            >
              <a className="px-0 font-bold hover:text-hov md:pb-4">
                <i className="mr-2 text-icn md:hidden">
                  <FontAwesomeIcon icon={faAngleRight} />
                </i>
                {nav.name}
                <span className="text-xs">{nav.sub}</span>
              </a>
            </ActiveLink>
          </li>
        ))}
      </ul>
    </>
  );
}
